import React from 'react';

import { useApp } from '../../store/AppContext';
import { effJiraKey } from '../../utils/jira';
import EpicOption from '../EpicOption';

export default function EpicImportDialog({
  epics,
  existingEpics,
  jClient,
  jPhase,
  selected,
  toggle,
}) {
  const { advanceEpicQueue, epicImportQueue, handleImportEpics } = useApp();
  return (
    <div
      className="modal w-[480px] max-w-[95vw] max-h-[80vh] flex flex-col"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="font-medium text-[14px] mb-[4px]">
        Importer les Epics Jira — {effJiraKey(jPhase, jClient)}
      </div>
      {epicImportQueue.length > 0 && (
        <div className="text-[11px] text-taupe mb-[4px]">
          Encore {epicImportQueue.length} phase{epicImportQueue.length > 1 ? 's' : ''} après
          celle-ci
        </div>
      )}
      <div className="text-[11px] text-grey mb-[14px]">
        Sélectionne les épics à importer comme briques
      </div>
      <div className="overflow-y-auto [flex:1] [border:0.5px_solid_#e5e3de] rounded-[8px] mb-[14px]">
        {epics.length === 0 && (
          <div className="p-[16px] text-[12px] text-grey-light text-center">
            Aucun Epic trouvé dans ce projet Jira
          </div>
        )}
        {epics.map((e) => (
          <EpicOption
            key={e.key}
            e={e}
            existingEpics={existingEpics}
            selected={selected}
            toggle={toggle}
          />
        ))}
      </div>
      <div className="flex justify-between items-center">
        <span className="text-[11px] text-grey">
          {selected.size} épic{selected.size > 1 ? 's' : ''} sélectionné
          {selected.size > 1 ? 's' : ''}
        </span>
        <div className="flex gap-[8px]">
          <button className="btn" onClick={advanceEpicQueue}>
            {epicImportQueue.length > 0 ? 'Passer' : 'Annuler'}
          </button>
          <button
            className="btn btn-primary"
            onClick={handleImportEpics}
            disabled={selected.size === 0}
          >
            Importer {selected.size > 0 ? `(${selected.size})` : ''}
          </button>
        </div>
      </div>
    </div>
  );
}
